import { toast } from "react-hot-toast";
import httpRequest from "../../axios/index";
import { LOGOUT, ADMIN_LOGOUT } from "../../constants/apiEndPoints";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase/FirebaseConfig";
// import { store } from "../../redux/store";
import { FirebasehandleUserDelete } from "./SocialLogin";

export const signouthandler = async () => {
  try {
    // const authState = store.getState()?.auth;
    await FirebasehandleUserDelete();
    await signOut(auth);
    const resp = await httpRequest.delete(LOGOUT);
    if (resp.status) {
      toast.success(resp?.data?.message);
      return resp;
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  }
};
export const AdminSignouthandler = async () => {
  try {
    // const authState = store.getState()?.auth;
    await FirebasehandleUserDelete();
    await signOut(auth);
    const resp = await httpRequest.delete(ADMIN_LOGOUT);
    if (resp.status) {
      toast.success(resp?.data?.message);
      return resp;
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  }
};
